import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../contexts/ThemeContext';
import Icon from '../Icon/Icon';
import './ThemeSwitcher.scss';
import Button from '../Button';

interface ThemeSwitcherProps {
  variant?: 'default' | 'mobile';
}

const ThemeSwitcher: React.FC<ThemeSwitcherProps> = ({ variant = 'default' }) => {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();

  const isDarkMode = theme === 'dark';

  return (
    <Button
      variant="ghost"
      size="sm"
      className={`theme-switcher theme-switcher--${variant}`}
      onClick={toggleTheme}
      aria-label={t('navigation.toggleTheme')}
      title={t('navigation.toggleTheme')}
    >
      <div className={`theme-switcher__container ${isDarkMode ? 'theme-switcher__container--dark' : 'theme-switcher__container--light'}`}>
        <div className={`theme-switcher__icon-wrapper ${isDarkMode ? 'theme-switcher__icon-wrapper--active' : ''}`}>
          <Icon 
            name="luna"
            size={variant === 'mobile' ? 16 : 18}
            alt="Luna"
            className="theme-switcher__icon"
          />
        </div>
        <div className={`theme-switcher__icon-wrapper ${!isDarkMode ? 'theme-switcher__icon-wrapper--active' : ''}`}>
          <Icon 
            name="sol"
            size={variant === 'mobile' ? 16 : 18}
            alt="Sol"
            className="theme-switcher__icon"
          />
        </div>
      </div>
    </Button>
  );
};

export default ThemeSwitcher; 